import { partition } from 'remeda'

/**
 * Generates a sequence of values while isValid is true
 * @param generator Generates the next value from the current value
 * @param isValid Adds the values in the sequence while this predicate is true
 * @param initialValue The first value of the sequence
 */
export const generateWhile = <T>({
  generator,
  isValid,
  initialValue,
}: {
  generator: (value: T) => T
  isValid: (value: T) => boolean
  initialValue: T
}): T[] => {
  const result: T[] = []
  let currentValue = initialValue
  while (isValid(currentValue)) {
    result.push(currentValue)
    currentValue = generator(currentValue)
  }
  return result
}

/**
 * Adds value to the list if not already inside, otherwise removes it
 */
export const toggleValueInList = <T>(values: T[], value: T): T[] => {
  const [withoutValue, withValue] = partition(values, (v) => v !== value)
  return withValue.length ? withoutValue : withoutValue.concat(value)
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const asyncNoop = async (): Promise<void> => {}
